import React from 'react';

class EditSectionLinkedDropdown extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      alert: this.props.alert === undefined ? false : this.props.alert.toLowerCase() === 'false' ? false : this.props.alert.toLowerCase() === 'true' ? true : this.prop.alert,
      columnName: this.props.columnName === undefined ? '' : this.props.columnName,
      id: this.props.id === undefined ? '' : this.props.id,
      height: this.props.height === undefined ? '32px' : this.props.height,
      width: this.props.width === undefined ? 'auto' : this.props.width,
      value: this.props.value === undefined ? '' : this.props.value,
      readonly: this.props.readonly === undefined ? false : true,
      visible: this.props.visible === undefined ? true : this.props.visible,
      hasError: false,
      error: {},
      info: {}
    };

    this.onChange = this.onChange.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( newprops ){
    this.setState( {
      alert: newprops.alert === undefined ? false : newprops.alert.toLowerCase() === 'false' ? false : newprops.alert.toLowerCase() === 'true' ? true : this.prop.alert,
      columnName: newprops.columnName === undefined ? '' : newprops.columnName,
      id: newprops.id === undefined ? '' : newprops.id,
      height: newprops.height === undefined ? '32px' : newprops.height,
      width: newprops.width === undefined ? 'auto' : newprops.width,
      value: newprops.value === undefined ? '' : newprops.value,
      readonly: newprops.readonly === undefined ? false : newprops.readonly,
      visible: newprops.visible === undefined ? true : newprops.visible,
    } );
  }

  onChange( e ){
    this.setState( {value: e.target.value} );

    if( this.props.onChanged !== undefined ){
      e.target.column = this.props.columnName;
      this.props.onChanged( e );
    }
  }

  render(){

    const alert = this.state.alert;
    let options = this.props.options === undefined ? [] : this.props.options;
    const id = this.state.id;
    const height = this.state.height;
    const width = this.state.width;
    let value = this.state.value === undefined ? '' : this.state.value;

    // Fixes option not bring in the value
    if( options.length > 0 && value === '' ){
      value = options[0].id;
    }

    let styles = {
      'width': width,
      'height': height,
      'fontSize': '100%'
    };

    let className = ( alert === true ? 'edit-section-dropdown alert' : 'edit-section-dropdown' );

    let readonly = this.state.readonly;
    let opts = {};

    if( readonly === true ) {
      opts['disable'] = this.state.readonly.toString();
    }
    opts['value'] = this.state.value;

    if( ( this.state.visible === false ) || ( this.state.hasError === true ) ) {
      return(
        <div></div>
      );

    } else {

      if ( options.length === 0 ) {
        return (
          <select key={id} id={id} className={className} style={styles} onChange={this.onChange} {...opts} >
            {this.props.children}
          </select>
        );
      } else {

        let position = 1;
        let key = '';
        let optionItems;

        optionItems = options.map( ( option, index ) => {
          key = 'edit-section-dropdown-option-' + position.toString();
          position += 1;
          return (
            <option key={key} value={option.value}>{option.text}</option> );
        } );
        return (
          <select key={id} id={id} value={this.state.value} className={className} style={styles} onChange={this.onChange} {...opts}>
            {optionItems}
          </select>
        );
      }
    }
  }

}

export default EditSectionLinkedDropdown;



// WEBPACK FOOTER //
// ./src/presentation/EditSectionLinkedDropdown.js